import React, { useEffect, useState } from 'react';
import productPageImage from '../../assets/productPageImage.png';
import filterIcon from '../../assets/filter.png';
import menu from '../../assets/menu.png';
import { Filters, Loading } from '../../components';
import collection1 from '../../assets/collection1.svg';
import collection2 from '../../assets/collection2.svg';
import collection3 from '../../assets/collection3.svg';
import collection4 from '../../assets/collection4.svg';
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Button,
} from '@chakra-ui/react';
import FilterSidebar from '../../components/Filters/FilterSidebar';
import { FaCaretUp } from 'react-icons/fa';
import Pagination from '../../components/Pagination/Pagination';
import { useFilterContext } from '../../context/filter_context';
import ProductList from './ProductList';
import axios from 'axios';
import emptyGridView from '../../assets/emptyGridView.png';
import fillListView from '../../assets/fillListView.png';
import whiteListView from '../../assets/whiteListView.svg';
import ProductGridView from './ProductGridView';
import { useProductsContext } from '../../context/products_context';
import { useLocation, useHistory } from 'react-router-dom';
import { useMemo } from 'react';
import { useUserContext } from '../../context/user_context';
import FilterLoader from '../../components/FilterLoader/FilterLoader';
import useDebounce from '../../hooks/useDebounce';
import { FaSearch } from 'react-icons/fa';
const ProductPage = () => {
  const options = [
    { label: 'New Arrivals', value: 'createdAt' },
    { label: 'Price Low to High', value: 'price' },
    { label: 'Price High to Low', value: 'price' },
  ];

  const [sortOptions, setSortOptions] = useState(options);
  const [showSortOptions, setShowSortOptions] = useState(false);
  const [selected, setSelected] = useState(options[1]);
  const [filterOptions, setFilterOptions] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [placement] = useState('left');
  const { products, fetchProducts, total_products, products_loading } =
    useProductsContext();
  const [totalItems, setTotalItems] = useState(total_products);
  const [currentPage, setCurrentPage] = useState(1);
  const [isListView, setIsListView] = useState(true);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { currentUser } = useUserContext();

  const history = useHistory();
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const category = searchParams.get('category');
  const [subCategories, setSubcategories] = useState([]);
  const [mobileFilters, setMobileFilters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userCartItems, setUserCartItems] = useState([]);
  const [userWishlistItems, setUserWishlistItems] = useState([]);
  const [minValue, setMinValue] = useState(1);
  const [maxValue, setMaxValue] = useState(1000000);
  const [searchValue, setSearchValue] = useState('');
  const debouncedSearchValue = useDebounce(searchValue, 500);
  const handlePageClick = (pagenumber) => {
    setCurrentPage(pagenumber);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const filters = [];
    for (const [key, value] of searchParams.entries()) {
      if (key !== 'category') {
        filters.push({
          type: key,
          options: value.split(','),
        });
      }
    }

    if (category) {
      filters.push({
        type: 'Category',
        options: [category],
      });
    }

    setSelectedFilters(filters);
  }, [category, searchParams]);

  useEffect(() => {
    const queryParams = new URLSearchParams();
    let hasEntry = false;
    selectedFilters.forEach((filter) => {
      if (filter.options.length > 0 && !searchParams.get(filter.type)) {
        hasEntry = true;
        queryParams.set(filter.type, filter.options.join(','));
      }
    });
    if(hasEntry){
      history.push({ search: queryParams.toString() });
    }
  }, [selectedFilters, history]);

  useEffect(() => {
    setTotalItems(total_products);
  }, [total_products]);
  const getData = async () => {
    let metaloptions = selectedFilters?.find((e) => e?.type === 'Metal Type');
    let categoryOptions = selectedFilters?.find((e) => e?.type === 'Category');
    let typeOptions = selectedFilters?.find((e) => e?.type === 'Type');
    let sortValue =
      selected.value === 'createdAt'
        ? 'createdAt:desc'
        : selected.label === 'Price Low to High'
        ? 'price:asc'
        : selected.label === 'Price High to Low'
        ? 'price:desc'
        : '';
    await fetchProducts(
      currentPage,
      categoryOptions?.options?.length > 0 ? categoryOptions?.options : "",
      metaloptions?.options?.length > 0 ? metaloptions?.options : "",
      sortValue,
      minValue,
      maxValue,
      debouncedSearchValue,
      typeOptions?.options?.length > 0 ? typeOptions?.options : ""
    );
    setLoading(false);
  };
  useEffect(() => {
    getData();
  }, [
    selectedFilters,
    selected,
    currentPage,
    debouncedSearchValue,
    minValue,
    maxValue,
  ]);
  useEffect(() => {
    let isMounted = true;
    const getData = async () => {
      setIsLoading(true);
      try {
        let res = await axios.get(
          `${process.env.REACT_APP_BACKEND_HOST}/api/category/all`
        );

        if (isMounted) {
          setFilterOptions([
            {
              name: 'Type',
              options: [
                { _for: 'Men', id: 1 },
                { _for: 'Women', id: 2 },
                { _for: 'Kids', id: 3 },
              ],
            },
            { name: 'Category', options: [...res?.data?.data] },
          ]);
        }
        let res3 = await axios.get(
          `${process.env.REACT_APP_BACKEND_HOST}/api/subCategory/all`
        );
        setSubcategories(res3.data.data);
        setIsLoading(false);
      } catch (err) {
        if (isMounted) setIsLoading(false);
      }
    };

    getData();
    return () => {
      isMounted = false;
    };
  }, []);

  const checkCartStatus = async () => {
    let isMounted = true;
    try {
      let userid = currentUser?.id;

      if (currentUser) {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_HOST}/api/user/addtocart/${userid}`
        );
        setUserCartItems(response.data.data);
      }
    } catch (e) {
      if (isMounted) {
        setLoading(false);
      }
    }
    return () => {
      isMounted = false;
    };
  };

  const checkWishlistStatus = async () => {
    try {
      if (currentUser) {
        const userid = currentUser.id;

        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`
        );

        setUserWishlistItems(response.data.data);
      }
    } catch (err) {
      console.error('Error checking wishlist:', err);
    }
  };

  useEffect(() => {
    if (currentUser) {
      const getData = async () => {
        setIsLoading(true);
        await checkCartStatus();
        await checkWishlistStatus();
        setIsLoading(false);
      };
      getData();
    }
  }, [currentUser]);
  return (
    <div className='flex flex-col bg-white w-full'>
      {!isLoading && (
        <>
          <img
            src={productPageImage}
            alt='product banner'
            className='w-full object-cover'
          />

          <div className='flex justify-between items-center px-5 py-3 border-b border-gray-300 flex-wrap gap-3'>
            <div className='items-center gap-3 flex flex-row'>
              <div className='hidden md:flex gap-3'>
                <img src={filterIcon} alt='filter' className='w-5 h-5' />

                <p className='text-gray-800 font-medium'>Filter</p>
              </div>
              <div className='border border-gray-400 h-5 hidden md:block' />

              <img
                src={isListView ? menu : whiteListView}
                onClick={() => setIsListView(true)}
                className='h-6 w-6'
              />
              <img
                src={isListView ? emptyGridView : fillListView}
                onClick={() => setIsListView(false)}
                className='h-6 w-6'
              />
            </div>
            <div className='flex items-center gap-2 md:hidden'>
              <Button
                onClick={onOpen}
                variant='outline'
                colorScheme='gray'
                size='sm'
                leftIcon={
                  <img src={filterIcon} alt='filter' className='w-4 h-4' />
                }
              >
                Filters
              </Button>
              <div
                className='items-center rounded-lg pl-2 w-full border flex md:hidden transition-all duration-200 border-[#B1832E] bg-white'
                style={{ height: '35px', width: '180px' }}
              >
                <FaSearch
                  className={`text-md ${
                    searchValue === '' ? 'block' : 'hidden'
                  } text-[#B1832E]`}
                />

                <input
                  type='text'
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  placeholder='Search...'
                  className='outline-none h-8 py-2 rounded-md w-full bg-[#ffffff] shadow-none focus:shadow-none 
                    focus:outline-none focus:ring-0'
                  style={{ width: '140px' }}
                />
              </div>
            </div>
            <div className='w-full flex items-center gap-3 justify-between'>
              <p className='text-sm text-[#B1832E]'>{totalItems} products</p>
              <div className='relative flex gap-3 '>
                <div
                  className='items-center rounded-lg pl-2 w-full border hidden md:flex transition-all duration-200 border-[#B1832E] bg-white group'
                  style={{ height: '40px', width: '180px' }}
                >
                  <FaSearch
                    className={`text-md ${
                      searchValue === '' ? 'block' : 'hidden'
                    } text-[#B1832E]`}
                  />

                  <input
                    type='text'
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    placeholder='Search...'
                    className='outline-none h-8 py-2 rounded-md hidden md:block w-full placeholder:text-gray-400 bg-[#ffffff] shadow-none focus:shadow-none 
                    focus:outline-none focus:ring-0'
                    style={{ width: '150px', marginRight: '0px' }}
                  />
                </div>

                <div className='flex items-center gap-2'>
                  <p className='text-gray-800 font-medium'>Sort by:</p>
                  <select
                    value={selected.label}
                    onChange={(e) => {
                      const selectedOption = options.find(
                        (opt) => opt.label === e.target.value
                      );
                      setSelected(selectedOption);
                    }}
                    className='border border-gray-300 rounded-md px-2 py-1'
                  >
                    {options.map((opt) => (
                      <option key={opt.value} value={opt.label}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <Drawer placement={placement} onClose={onClose} isOpen={isOpen}>
            <DrawerOverlay />
            <DrawerContent>
              <DrawerCloseButton />
              <DrawerHeader borderBottomWidth='1px'>Filters</DrawerHeader>
              <DrawerBody>
                <FilterSidebar
                  filters={filterOptions}
                  selectedFilters={selectedFilters}
                  setSelectedFilters={setSelectedFilters}
                  subCategories={subCategories}
                  setCurrentPage={setCurrentPage}
                  mobileFilters={mobileFilters}
                  setMobileFilters={setMobileFilters}
                  min={minValue}
                  max={maxValue}
                  setMinimumValue={setMinValue}
                  setMaximumValue={setMaxValue}
                />
              </DrawerBody>
            </DrawerContent>
          </Drawer>
          <div className='flex flex-col md:flex-row gap-4 p-4'>
            <div className='hidden md:block md:w-[20%]'>
              <Filters
                filters={filterOptions}
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
                subCategories={subCategories}
                setCurrentPage={setCurrentPage}
                setLoading={setLoading}
                min={minValue}
                max={maxValue}
                setMinimumValue={setMinValue}
                setMaximumValue={setMaxValue}
              />
            </div>

            <div className='w-full relative'>
              <div
                className={`flex ${
                  isListView
                    ? 'w-full grid grid-flow-row lg:grid-cols-4 md:grid-cols-3 grid-cols-2 mb-3 gap-4'
                    : 'flex-col flex-wrap justify-center lg:justify-start gap-2 opacity-100'
                }`}
              >
                {!isLoading &&
                  products?.map((e) => {
                    return isListView ? (
                      <ProductList
                        data={e}
                        id={e.id}
                        userWishlistItems={userWishlistItems}
                        userCartItems={userCartItems}
                        checkCartStatus={checkCartStatus}
                        checkWishlistStatus={checkWishlistStatus}
                        setLoading={setLoading}
                        key={e.id}
                      />
                    ) : (
                      <ProductGridView
                        data={e}
                        id={e.id}
                        userWishlistItems={userWishlistItems}
                        userCartItems={userCartItems}
                        checkCartStatus={checkCartStatus}
                        checkWishlistStatus={checkWishlistStatus}
                        setLoading={setLoading}
                        key={e.id}
                      />
                    );
                  })}
              </div>
              {!products_loading &&
                products?.length <= 0 &&
                !isLoading &&
                !loading && (
                  <p className='text-xl font-semibold top-[50%] left-0 w-full z-50 flex justify-center '>
                    No products found
                  </p>
                )}
            </div>
          </div>
          <div className='mb-3'>
            {totalItems >= 20 && (
              <Pagination
                totalItems={total_products}
                itemsPerPage={20}
                currentPage={currentPage}
                handlePageClick={handlePageClick}
              />
            )}
          </div>
        </>
      )}
      {!isLoading && (loading || products_loading) && (
        <div className='fixed top-0 w-full h-full z-50 flex justify-center items-center bg-[#00000010]'>
          <div className='-mt-[60px]'>
            <FilterLoader />
          </div>
        </div>
      )}
      {isLoading && <Loading />}{' '}
    </div>
  );
};

export default ProductPage;
